const DEFAULT_AMAP_KEY = process.env.VUE_APP_AMAP_KEY || '18e11d7f0c2faf9f09f9a1ef6b413faa'
const DEFAULT_AMAP_SECURITY_CODE = process.env.VUE_APP_AMAP_SECURITY_CODE || 'd0e2e4791de5910ccc206bb0fa0923c8'

let amapLoaderPromise = null

export function loadAmap() {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('AMap can only be loaded in browser runtime.'))
  }

  if (window.AMap) {
    return Promise.resolve(window.AMap)
  }

  if (amapLoaderPromise) {
    return amapLoaderPromise
  }

  amapLoaderPromise = new Promise((resolve, reject) => {
    if (!DEFAULT_AMAP_KEY) {
      reject(new Error('Missing AMap API key.'))
      return
    }

    if (DEFAULT_AMAP_SECURITY_CODE) {
      window._AMapSecurityConfig = {
        securityJsCode: DEFAULT_AMAP_SECURITY_CODE
      }
    }

    const existingScript = document.querySelector('script[data-amap-loader="true"]')
    if (existingScript) {
      existingScript.addEventListener('load', () => {
        window.AMap ? resolve(window.AMap) : reject(new Error('AMap SDK loaded without window.AMap.'))
      })
      existingScript.addEventListener('error', () => reject(new Error('Failed to load AMap SDK.')))
      return
    }

    const script = document.createElement('script')
    script.src = `https://webapi.amap.com/maps?v=2.0&key=${DEFAULT_AMAP_KEY}&plugin=AMap.PlaceSearch,AMap.Geocoder,AMap.Scale,AMap.ToolBar`
    script.async = true
    script.defer = true
    script.dataset.amapLoader = 'true'
    script.onload = () => {
      window.AMap ? resolve(window.AMap) : reject(new Error('AMap SDK loaded without window.AMap.'))
    }
    script.onerror = () => reject(new Error('Failed to load AMap SDK.'))
    document.head.appendChild(script)
  })

  return amapLoaderPromise
}

export function loadAmapPlugins(plugins = []) {
  return loadAmap().then(AMap => new Promise((resolve, reject) => {
    if (!plugins.length || typeof AMap.plugin !== 'function') {
      resolve(AMap)
      return
    }

    AMap.plugin(plugins, () => {
      const missingPlugin = plugins.find(pluginName => {
        const pluginKey = pluginName.replace(/^AMap\./, '')
        return !AMap[pluginKey]
      })

      if (missingPlugin) {
        reject(new Error(`AMap plugin is not ready: ${missingPlugin}`))
        return
      }

      resolve(AMap)
    })
  }))
}
